import {CHANGED} from '../actions/languageActions';

let initialState: any = null;

if(sessionStorage.getItem("Language") == null || sessionStorage.getItem("Language") == undefined ){
    initialState = "en";
}
else {
    initialState = sessionStorage.getItem("Language");
}

const languageReducer = (state=initialState,action:any)=>{

    switch(action.type){
        case CHANGED: {
            return action.payload
        }
        default:{
            return state
        }
    }
}
export default languageReducer;